var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInverseLogoGraboxy2Fa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "304px",
    height: "56px",
    viewBox: "0 0 304 56",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo-2fa") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100%",
    y1: "34.2891377%",
    x2: "60.949281%",
    y2: "10.4002047%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF3355",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C766F4",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "99.9996514%",
    y1: "28.2547112%",
    x2: "55.697235%",
    y2: "1.15283901%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF3355",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C766F4",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100%",
    y1: "18.6878165%",
    x2: "50.3889635%",
    y2: "-11.6617046%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF3355",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C766F4",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "62.4992157%",
    y1: "18.6870588%",
    x2: "46.9138223%",
    y2: "9.15294118%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF3355",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C766F4",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "99.9998876%",
    y1: "18.6870787%",
    x2: "50.388764%",
    y2: "-11.6621348%",
    id: "linearGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF3355",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C766F4",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(-23.000000, -217.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo-2fa",
    transform: "translate(23.000000, 217.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.0000314,42 L18.9999686,42 C18.2043608,42 17.4413176,41.6839524 16.8786824,41.1213788 C16.3160471,40.5587424 16,39.7956979 16,39.0000258 L16,28.0000369 C16,27.2043649 16.3160471,26.4413203 16.8786824,25.878684 C17.4413176,25.3160476 18.2043608,25 18.9999686,25 L37.0000314,25 C37.7956392,25 38.5586824,25.3160476 39.1213176,25.878684 C39.6839529,26.4413203 40,27.2043649 40,28.0000369 L40,39.0000258 C40,39.7956979 39.6839529,40.5587424 39.1213176,41.1213788 C38.5586824,41.6839524 37.7956392,42 37.0000314,42 Z M18.9999686,27.0000037 C18.7348078,27.0000037 18.4804392,27.1053529 18.2928941,27.2928983 C18.105349,27.4804438 18,27.7348129 18,28.0000369 L18,39.0000258 C18,39.2652499 18.105349,39.519619 18.2928941,39.7071644 C18.4804392,39.8946471 18.7348078,40.0000591 18.9999686,40.0000591 L37.0000314,40.0000591 C37.2651922,40.0000591 37.5195608,39.8946471 37.7071059,39.7071644 C37.894651,39.519619 38,39.2652499 38,39.0000258 L38,28.0000369 C38,27.7348129 37.894651,27.4804438 37.7071059,27.2928983 C37.5195608,27.1053529 37.2651922,27.0000037 37.0000314,27.0000037 L18.9999686,27.0000037 Z",
    id: "Shape",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9999721,27 L20.0000279,27 C19.7348053,27 19.4804375,26.8946508 19.2928931,26.7071053 C19.1054114,26.5195598 19,26.2651906 19,25.9999665 L19,20.0000167 C19,17.8782241 19.842852,15.8433963 21.3431448,14.3430951 C22.8434376,12.8427939 24.878254,12 26.9999721,12 L29.0000279,12 C31.121746,12 33.1565624,12.8427939 34.6568552,14.3430951 C36.157148,15.8433963 37,17.8782241 37,20.0000167 L37,25.9999665 C37,26.2651906 36.8945886,26.5195598 36.7071069,26.7071053 C36.5195625,26.8946508 36.2651947,27 35.9999721,27 Z M21.0000558,24.9999958 L34.9999442,24.9999958 L34.9999442,20.0000167 C34.9999442,18.4086722 34.3678523,16.8825828 33.2426484,15.7573098 C32.1173817,14.6320996 30.5913008,13.9999414 29.0000279,13.9999414 L26.9999721,13.9999414 C25.4086992,13.9999414 23.8826183,14.6320996 22.7573516,15.7573098 C21.6321477,16.8825828 21.0000558,18.4086722 21.0000558,20.0000167 L21.0000558,24.9999958 Z",
    id: "Shape",
    fill: "url(#linearGradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28,34 C27.6044522,34 27.2177537,33.8826678 26.8888435,33.6629365 C26.5599334,33.4431424 26.3036194,33.1308003 26.1522153,32.7653762 C26.0008739,32.3998894 25.9612817,31.9977598 26.0383955,31.6098105 C26.1155721,31.2218612 26.3060664,30.8654723 26.5857844,30.5857573 C26.8655023,30.306105 27.2218322,30.1156127 27.6098483,30.0384369 C27.9978017,29.9612612 28.3999354,30.000853 28.7653633,30.1522555 C29.1307912,30.3035952 29.4431994,30.5599693 29.662933,30.888876 C29.8827293,31.2177828 30,31.6044145 30,32.0000186 C30,32.530398 29.7893017,33.0391305 29.4142111,33.4142172 C29.0391205,33.7892412 28.5304454,34 28,34 Z",
    id: "Path",
    fill: "url(#linearGradient-3)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "url(#linearGradient-4)",
    points: "29 33 27 33 27 37 29 37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.087895,23.8772852 C243.380878,19.3285492 247.465189,18 251.241555,18 C254.959949,18 259,19.472934 259,24.0072192 C259,28.7725325 255.10644,29.9855369 251.066389,29.9855369 C249.089687,29.9855369 246.088791,30.4621051 246.088791,33.0035973 L246.088791,35.0396812 L259,35.0396812 L259,38 L243,38 C243,36.3393289 243,34.6642685 243,33.0035973 C243,28.4837629 247.142907,27.1841152 251.03709,27.1841152 C252.837379,27.1841152 255.838275,26.6209038 255.838275,24.0505101 C255.838275,21.5667595 253.657108,20.8014217 251.227218,20.7147785 C248.914521,20.7147785 246.337515,21.5379195 246.279542,23.8483837 L243.087895,23.8483837 L243.087895,23.8772852 Z",
    id: "Path",
    fill: "#EB3865"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.5443054,23.8050977 C86.2537919,22.6731046 84.3850119,22.0345729 82.7980974,22.0345729 C78.9859633,22.0345729 76.4643427,24.2259623 76.4643427,28.5362676 C76.4643427,31.3663122 78.0512573,34.8928919 82.7980974,34.8928919 C84.2364955,34.8928919 85.5270091,34.6752247 87.1139236,33.4851664 L87.1139236,30.3068542 L82.2937733,30.3068542 L82.2937733,26.6350806 L91,26.6350806 L91,35.3282882 C89.2797366,37.7954717 86.4762507,39 82.7235232,39 C74.9513703,39 72,33.7028335 72,28.5362676 C72,22.948837 75.3817523,18 82.7829297,18 C85.5124734,18 88.033462,18.7111287 90.3326237,21.0331801 L87.5443054,23.8050977 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114,38 L108.96119,38 L103.773547,31.4550492 L100.533408,31.4550492 L100.533408,38 L96,38 L96,18 C99.3148726,18 102.346645,18 105.587417,18 C110.492593,18 113.078498,21.1994273 113.078498,24.7640642 C113.078498,27.3937348 112.290629,29.6727618 108.396256,31.0313886 L113.940466,37.6493566 L113.940466,38 L114,38 Z M100.518842,21.8422012 L100.518842,27.671299 L105.705851,27.671299 C107.802188,27.671299 108.664156,26.108125 108.664156,24.8955321 C108.664156,23.5369053 107.727455,21.8422012 105.631751,21.8422012 L100.518842,21.8422012 Z",
    id: "Shape",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.65183,34.5814595 L123.274052,34.5814595 L121.832236,38 L117,38 L126.010081,18 L130.915801,18 L140,38 L135.168397,38 L133.65183,34.5814595 Z M128.462941,22.5580541 L124.924284,30.6661791 L131.912275,30.6661791 L128.462941,22.5580541 Z",
    id: "Shape",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.099007,18.0146283 C157.002204,18.0146283 160.312675,19.7238987 160.312675,23.4200658 C160.312675,25.0562568 159.568532,26.6194308 157.594284,27.4813801 C160.25185,28.4017803 161.345419,30.973 160.905402,33.310478 C160.312675,36.5099053 157.518577,38 153.387605,38 C150.077134,38 146.386826,38 143,38 L143,18 L153.099007,18 L153.099007,18.0146283 Z M147.434452,25.7721097 L153.038828,25.7721097 C154.875894,25.7721097 155.757219,25.0562568 155.757219,23.8582923 C155.757219,22.7187788 154.875894,21.7984407 153.099007,21.7984407 L147.434452,21.7984407 L147.434452,25.7721097 Z M147.434452,34.1724273 L153.099007,34.1724273 C155.164492,34.1724273 156.121526,33.3251063 156.121526,31.8934001 C156.121526,30.4762602 155.088784,29.5412939 153.023299,29.5412939 C151.185586,29.5412939 149.272165,29.5412939 147.419569,29.5412939 L147.419569,34.1724273 L147.434452,34.1724273 Z",
    id: "Shape",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.499686,42 C170.071939,42 164,35.9250062 164,28.5 C164,21.0603006 170.071939,15 177.499686,15 C184.928061,15 191,21.0749937 191,28.5 C191,35.9250062 184.928061,42 177.499686,42 Z M177.499686,18.8445845 C172.208955,18.8445845 167.846378,23.1293361 167.846378,28.4853069 C167.846378,33.8412776 172.135481,38.1260919 177.499686,38.1260919 C182.791045,38.1260919 187.153622,33.8412776 187.153622,28.4853069 C187.138551,23.1293361 182.775974,18.8445845 177.499686,18.8445845 Z",
    id: "Shape",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "207.098438 18 211.927521 18 211.927521 18.2191133 205.282158 27.9634916 212 37.8539038 212 38 207.11318 38 202.499692 30.9583716 197.88682 38 193 38 193 37.8539038 199.7031 27.9634916 193.129602 18.2191133 193.129602 18 197.959299 18 202.572172 25.1146455"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "224.90504 25.9765947 229.916212 18.0145661 235 18.0145661 235 18.2337416 227.01775 30.0379713 227.01775 38 222.632821 38 222.632821 30.0964224 215 18.2191133 215 18 220.083788 18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.253853,25.2030157 C182.816716,25.8646348 182.153629,26.3007166 181.279999,26.3007166 C179.89413,26.3007166 178.718804,25.1277939 178.718804,23.744391 C178.718804,23.1579296 179.005093,22.7218479 179.306788,22.2857021 C178.869651,22.2105443 178.508259,22 177.99602,22 C174.712042,22 172,24.7067693 172,28 C172,31.2932307 174.696637,34 177.99602,34 C181.279999,34 183.992041,31.2932307 183.992041,28 C184.05238,26.9623997 183.766092,26.0150145 183.253853,25.2030157 Z",
    id: "Path",
    fill: "#EB3865"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "161 49.6116309 164.501084 52 173 39.388307 169.498918 37"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#EB3865",
    points: "265 38 265 18 279 18 279 21.1186483 268.167429 21.1186483 268.167429 27.2093647 278.464807 27.2093647 278.464807 30.1815575 268.167429 30.1815575 268.167429 38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.552241,33.8040778 L287.432422,33.8040778 L285.49679,38 L282,38 L291.214221,18 L294.785779,18 L304,38 L300.50321,38 L298.552241,33.8040778 Z M292.99968,21.3771829 L288.6632,30.8947549 L297.351497,30.8947549 L292.99968,21.3771829 Z",
    id: "Shape",
    fill: "#EB3865"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28,2.51685393 C13.9260674,2.51685393 2.51685393,13.9260674 2.51685393,28 C2.51685393,42.0739326 13.9260674,53.4831461 28,53.4831461 C42.0739326,53.4831461 53.4831461,42.0739326 53.4831461,28 C53.4831461,13.9260674 42.0739326,2.51685393 28,2.51685393 Z M0,28 C0,12.536009 12.536009,0 28,0 C43.463991,0 56,12.536009 56,28 C56,43.463991 43.463991,56 28,56 C12.536009,56 0,43.463991 0,28 Z",
    id: "Shape",
    fill: "url(#linearGradient-5)"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInverseLogoGraboxy2Fa);
export default __webpack_public_path__ + "static/media/inverse-logo-graboxy-2fa.de5843847c0ffd0f13384cb7835169f2.svg";
export { ForwardRef as ReactComponent };